import { Component, EventEmitter, Input, Output, TrackByFunction } from '@angular/core';
import { Sale, Client, Payment, Tax, Tip } from 'src/app/models';
import { Map, List } from 'immutable';

@Component({
  selector: 'smr-sale-details',
  templateUrl: './sale-details.component.html',
  styleUrls: ['./sale-details.component.scss'],
})
export class SaleDetailsComponent  {

  @Input() sale: Sale;

  @Input() isConfirmationPage: boolean = false;

  constructor() { }

  trackByPaymentID: TrackByFunction<Payment> = (index, payment) => payment.id;

  trackByTaxID: TrackByFunction<Tax> = (index, tax) => tax.id;

  trackByTipID: TrackByFunction<Tip> = (index, tip) => tip.id;

  trackByClientID: TrackByFunction<Client> = (index, client) => client.id;

  ngOnInit() {}

}
